<template>
  <div>

    <template v-if="dataShowLabel">
      <h6>{{dataTitle}}</h6>
      <div class="btn-inpt">
        <v-text-field :label="$t('message.campaigns.message.text')"
                      v-model="buttonLabel"
                      :counter="dataMaxLength"
                      :maxlength="dataMaxLength"
                      :disabled="!dataOption"
                      @change="updateOptionText($event)"></v-text-field>
        <button :class="`advanced-config-activator ${hasAdvancedConfig ? 'active' : ''}`"
                @click="openAdvancedConfig"><i class="mdi mdi-settings pointer"></i></button>

      </div>
      <div v-if="showAdvancedConfig"
           class="advanced-config">
        <v-text-field v-if="!hasNextInteractionId"
                      :label="$t('message.campaigns.message.postAuthPage')"
                      v-model="postAuthUrl"
                      @change="updatePostAuthUrl"></v-text-field>

        <IntegrationLinkCheckbox :value="dataOption.integrationTrigger"
                                 center
                                 @select="linkIntegration" />
      </div>
    </template>

    <app-color-picker v-model="color"
                      :data-control-name="$t('message.campaigns.message.font')"
                      type="FONT"
                      :interaction="dataInteraction"
                      :eyedropper="eyedropper"
                      :data-show-checkbox="false"></app-color-picker>

    <app-color-picker v-model="backgroundColor"
                      :data-control-name="$t('message.campaigns.message.background')"
                      type="BACKGROUND"
                      :data-active="item.estilo && item.estilo.backgroundColor && item.estilo.backgroundColor.active"
                      :interaction="dataInteraction"
                      :eyedropper="eyedropper"
                      @checkbox="(evt) => checkbox({attr: 'backgroundColor', value: evt})"></app-color-picker>

    <app-color-picker v-model="borderColor"
                      :data-control-name="$t('message.campaigns.message.border')"
                      type="BORDER"
                      :data-active="item.estilo && item.estilo.borderColor && item.estilo.borderColor.active"
                      :interaction="dataInteraction"
                      :eyedropper="eyedropper"
                      @checkbox="(evt) => checkbox({attr: 'borderColor', value: evt})"></app-color-picker>

  </div>
</template>

<script>
    import IntegrationLinkCheckbox from '@/components/integration/IntegrationLinkCheckbox.vue';
    import EventBus from '@packages/event-bus'
    import AppColorPicker from './ColorPicker'
    import _ from 'lodash'

    export default {
        components: {
            AppColorPicker,
            IntegrationLinkCheckbox
        },

        props: {
            dataTitle: {
                type: String,
                required: false
            },

            dataShowLabel: {
                type: Boolean,
                required: false,
                default: true,
            },

            dataInteraction: {
                type: Object,
                required: true
            },

            dataOption: {
                type: Object,
                required: false
            },

            dataMaxLength: {
                type: Number
            },

            eyedropper: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                inputValue: this.dataOption ? this.dataOption.nome : 'Continuar',
                postAuthUrl: this.dataOption ? this.dataOption.paginaPosAutenticacao : '',
                showAdvancedConfig: false,
            }
        },

        computed: {

            hasNextInteractionId() {
                return !!this.dataOption.proximaInteracaoId
            },
            hasAdvancedConfig() {
                return !!this.dataOption && (this.dataOption.paginaPosAutenticacao || this.dataOption.integrationTrigger)
            },
            color: {
                get() {
                    return this.get('color')
                },

                set(val) {
                    const payload = {color: val, attr: 'color'}

                     const isValid = this.isValidColorSelection(payload);

                    if(isValid) {
                        if (this.dataOption)
                            return this.setOption(payload)

                        this.set(payload)
                    }
                }
            },
            backgroundColor: {
                get() {
                    return this.get('backgroundColor')
                },
                set(val) {

                    const payload = {color: val, attr: 'backgroundColor'}

                    const isValid = this.isValidColorSelection(payload);

                    if(isValid) {
                        if (this.dataOption)
                            return this.setOption(payload)

                        this.set(payload)
                    }
                }
            },
            borderColor: {
                get() {
                    return this.get('borderColor')
                },
                set(val) {
                    const payload = {color: val, attr: 'borderColor'}

                    const isValid = this.isValidColorSelection(payload);

                    if(isValid) {
                        if (this.dataOption)
                            return this.setOption(payload)

                        this.set(payload)
                    }
                }
            },

            style() {
                const style = {}
                const item = this.dataOption ? this.dataOption : this.dataInteraction

                _.forEach(item.estilo, (val, key) => {
                    style[key] = val
                })

                return style
            },

            item() {
                return this.dataOption ? this.dataOption : this.dataInteraction
            },

            interactionStored() {
                return this.$store.state.interactions.list.find(interaction => interaction.id === this.dataInteraction.id)
            },

            buttonLabel: {
                get() {
                    return this.dataOption ? this.dataOption.nome : 'Continuar'
                },
                set() {
                    return
                }
            }
        },

        methods: {
            async linkIntegration(integrationId) {
                try {
                    if(integrationId) {
                        await this.$api.interactions.options.linkIntegration({
                            optionId: this.dataOption.id,
                            interactionId: this.dataInteraction.id,
                            advertisingId: this.dataInteraction.campanhaId,
                            integrationId
                        })
                        this.dataOption.integrationTrigger = integrationId
                    } else{
                        await this.$api.interactions.options.unlinkIntegration({
                            optionId: this.dataOption.id,
                            interactionId: this.dataInteraction.id,
                            advertisingId: this.dataInteraction.campanhaId,
                        })
                        this.dataOption.integrationTrigger = undefined
                    }

                    this.$emit('reload')
                } catch (error) {
                    console.log(error);
                }
            },
            openAdvancedConfig() {
                this.showAdvancedConfig = !this.showAdvancedConfig;
            },
            get(attr) {
                if (!this.item.estilo ||
                    !this.item.estilo[attr] ||
                    !this.item.estilo[attr].color)
                    return false

                return this.item.estilo[attr].color
            },

            set({color, attr}) {
                const style = _.cloneDeep(this.style)
                style[attr].color = color
                const data = {
                    estilo: style
                }

                this.$store.commit('SET_INTERACTION_DATA', {
                    interactionId: this.dataInteraction.id,
                    data
                })
                this.setTimeout({
                    interaction: this.dataInteraction,
                    data
                })
            },

            isValidColorSelection(val) {
                if(val.color.a > 0.5) {
                    return true;
                }

                const textAlpha = this.color.a;
                const backgroundAlpha = this.backgroundColor.a;
                const borderAlpha = this.borderColor.a;

                const isValid = {
                    'backgroundColor': textAlpha >= 0.5 || borderAlpha >= 0.5,
                    'borderColor': textAlpha >= 0.5 || backgroundAlpha >= 0.5,
                    'color': backgroundAlpha >= 0.5 || borderAlpha >= 0.5
                }[val.attr]


                if(!isValid) {
                    EventBus.$emit('show-message', {
                        type: 'ERROR',
                        message: this.$t('message.errorMessages.message.attributesOpacity')
                    })
                }

                return isValid;
            },

            isValidCheckboxSelection(value) {
                const isBackgroundActive = this.item.estilo.backgroundColor.active;
                const isBorderActive = this.item.estilo.borderColor.active;

                if(!value && (!isBackgroundActive || !isBorderActive)) {
                     EventBus.$emit('show-message', {
                        type: 'ERROR',
                        message: this.$t('message.errorMessages.message.borderOrBackgroundActive')
                    })

                    return false;
                }

                return true;

            },

            validateAlphaSelection() {},

            checkbox({ attr, value }) {
                const isValid = this.isValidCheckboxSelection(value);

                if(isValid) {
                    const item = this.dataOption ? this.dataOption : this.dataInteraction

                    item.estilo[attr].active = value

                    const payload = {
                        optionId: this.dataOption ? this.dataOption.id : null,
                        interactionId: this.dataInteraction.id,
                        advertisingId: this.dataInteraction.campanhaId,
                        data: {
                            estilo: item.estilo
                        }
                    }

                    this.dataOption ?
                        this.$api.interactions.options.edit(payload) :
                        this.$api.interactions.update(payload)
                }
            },

             updateOptionText(evt) {
                if(evt.length <= 1) {
                     return EventBus.$emit('show-message', {
                        type: 'ERROR',
                        message: this.$t('message.errorMessages.message.optionTwoCharacters')
                    })
                }


                this.$emit('change', evt);
            },

            updatePostAuthUrl(evt) {
                this.$emit('change-auth', evt);
            },

            setOption({color, attr}) {
                const option = _.cloneDeep(this.dataOption)
                option.estilo[attr].color = color
                const httpPayload = {
                    interaction: this.dataInteraction,
                    option: this.dataOption,
                    data: {
                        estilo: option.estilo
                    }
                }
                this.setTimeout(httpPayload)
                this.store(option)
            },

            setTimeout({interaction, option, data}) {
                if (this.timeout)
                    clearTimeout(this.timeout)

                this.timeout = setTimeout(() => this.commit({interaction, option, data}), 600)
            },

            commit({interaction, option, data}) {
                const payload = {
                    advertisingId: interaction.campanhaId,
                    interactionId: interaction.id,
                    optionId: option ? option.id : null,
                    data,
                }

                if (option)
                    return this.$api.interactions.options.edit(payload)

                this.$api.interactions.update(payload)
            },

            store(option) {
                const options = _.cloneDeep(this.dataInteraction.opcoes)
                const index = _.findIndex(options, (opt) => {
                    return opt.id === option.id
                })
                options[index] = option

                this.$store.commit('SET_INTERACTION_OPTIONS', {
                    interactionId: this.dataInteraction.id,
                    data: options
                })
            },

            setDefaultBackgroundColor({color, attr}) {
                this.set({color, attr}).then(() => this.$loader.interactions.load(this.dataInteraction.campanhaId))
            }
        },
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.btn-inpt {
  display: flex;

  .advanced-config-activator {
    &.active {
      color: $primary;
    }
  }
}

.advanced-config {
  background: #f6f6f6;
  margin: 5px -15px;
  padding: 5px 15px;
}
</style>
